import { z } from 'zod';
import { GameStatus } from '../stateMachine/gameStatus.js';

export const GameCategory = z.enum([
  'puzzle',
  'arcade',
  'idle',
  'strategy',
  'card',
  'board',
  'word',
  'trivia',
  'action',
  'adventure',
  'simulation',
  'sports',
  'racing',
  'music',
  'educational',
  'other',
]);

export type GameCategory = z.infer<typeof GameCategory>;

export const GameDifficulty = z.enum(['easy', 'medium', 'hard', 'expert']);

export type GameDifficulty = z.infer<typeof GameDifficulty>;

export const GameSchema = z.object({
  id: z.string().uuid(),
  slug: z.string().min(2).max(100).regex(/^[a-z0-9-]+$/),
  title: z.string().min(1).max(200),
  description: z.string().max(2000).optional().default(''),
  category: GameCategory,
  template_id: z.string().uuid().nullable(),
  version: z.string().regex(/^\d+\.\d+\.\d+$/),
  status: z.nativeEnum(GameStatus),
  difficulty: GameDifficulty,
  ai_score: z.number().min(0).max(100).default(0),
  retention_score: z.number().min(0).max(100).default(0),
  monetization_score: z.number().min(0).max(100).default(0),
  created_at: z.string().datetime(),
  published_at: z.string().datetime().nullable(),
});

export type Game = z.infer<typeof GameSchema>;

export const GameCreateInput = GameSchema.omit({
  id: true,
  created_at: true,
  published_at: true,
  ai_score: true,
  retention_score: true,
  monetization_score: true,
}).extend({
  status: z.nativeEnum(GameStatus).default(GameStatus.DRAFT),
  version: z.string().regex(/^\d+\.\d+\.\d+$/).default('0.1.0'),
  template_id: z.string().uuid().nullable().default(null),
  description: z.string().max(2000).optional().default(''),
});

export type GameCreateInput = z.infer<typeof GameCreateInput>;

export const GameUpdateInput = GameSchema.partial().omit({ id: true, created_at: true });

export type GameUpdateInput = z.infer<typeof GameUpdateInput>;
